import { isNil } from "lodash/fp"
import log from "loglevel"
import { inspect } from "./inspect"
import { httpRequest } from "../../functions/common"

log.setLevel(log.levels.DEBUG)

const env = process.env['REACT_APP_ENV'] ?? 'dev'


const baseName = 'miraiz-connect.jp'
const zoneName = `${{ prd: '', stg: '', int: 'dev.', dev: 'dev.', exp: 'dev.' }[env] as string
  }${baseName}`
const domainName = `webhook${{ prd: '', stg: '-stg', int: '-int', dev: '', exp: '-exp' }[env] as string
  }.tsunagu-series.${zoneName}`
const campaignDomainName = `api${{ prd: '', stg: '-stg', int: '-int', dev: '', exp: '-exp' }[env] as string
  }.tsunagu-series.${zoneName}`

export const sendRequestData = async (token: string, customerId: string | null): Promise<boolean> => {
  const result = await httpRequest('POST', `https://${domainName}/v1/tcidauth/campaign/katene-shopify`,
    { customerId, token },
    { Authorization: `Bearer ${token}` })
  if (isNil(result) || result.status !== 200) {
    log.error(`[functions.sendRequestData]`, inspect(result))
    return false
  }
  return true
}
export const isAlreadyRequestedApi = async (token: string, campaignCode: string): Promise<boolean | undefined> => {
  const result: {
    status: number
    data: {
      success: boolean
      result: boolean
    } | undefined
  } | undefined = await httpRequest('POST', `https://${domainName}/v1/tcidauth/requested/${campaignCode}`,
    { token },
    { Authorization: `Bearer ${token}` })
  if (isNil(result) || result.status !== 200 || isNil(result.data) || !result.data.success) {
    log.error(`[functions.isAlreadyRequestedApi]`, inspect(result))
    return undefined
  }
  return result.data.result
}
export const isAlreadyRequestedApiProcess = async (token: string, campaignCode: string, retryCount = 4): Promise<boolean | undefined> => {
  let result = await isAlreadyRequestedApi(token, campaignCode)
  let index = 0
  while (index < retryCount && isNil(result)) {
    result = await isAlreadyRequestedApi(token, campaignCode)
    index++
  }
  return result
}
// export const deleteTagsApi = async (customerId: string, campaignCode: string): Promise<boolean | undefined> => {
//   const result: {
//     status: number
//     data: {
//       success: boolean
//       registered?: boolean
//     } | undefined
//   } | undefined = await httpRequest('POST', `https://${campaignDomainName}/v1/campaign/delete/${campaignCode}`,
//     { customerId },
//   )
//   if (isNil(result) || result.status !== 202 || isNil(result.data) || !result.data.success) {
//     log.error(`[functions.sendRequestData]`, inspect(result))
//     return undefined
//   }
//   return result.data.registered
// }
export const setTagsApi = async (customerId: string, campaignCode: string, token: string): Promise<boolean | undefined> => {
  const result: {
    status: number
    data: {
      success: boolean
      registered?: boolean
    } | undefined
  } | undefined = await httpRequest('POST', `https://${campaignDomainName}/v1/campaign/${campaignCode}`,
    { customerId, token },
  )
  if (isNil(result) || result.status !== 200 || isNil(result.data) || !result.data.success) {
    log.error(`[functions.setTagsApi]`, inspect(result))
    return undefined
  }
  return result.data.registered
}
// export const deleteTagsApiProcess = async (customerId: string, campaignCode: string, retryCount = 4): Promise<boolean | undefined> => {
//   let result = await deleteTagsApi(customerId, campaignCode)
//   let index = 0
//   while (index < retryCount && isNil(result)) {
//     result = await deleteTagsApi(customerId, campaignCode)
//     index++
//   }
//   return result
// }
export const setTagsApiProcess = async (customerId: string, campaignCode: string, token: string, retryCount = 4): Promise<boolean | undefined> => {
  let result = await setTagsApi(customerId, campaignCode, token)
  let index = 0
  while (index < retryCount && isNil(result)) {
    result = await setTagsApi(customerId, campaignCode, token)
    index++
  }
  return result
}
// export const isRegisteredKateneApi = async (token: string): Promise<boolean | undefined> => {
//   const result: {
//     status: number
//     data: {
//       success: boolean
//       result: boolean
//     } | undefined
//   } | undefined = await httpRequest('POST', `https://${domainName}/v1/tcidauth/isRegisteredKatene`,
//     {},
//     { Authorization: `Bearer ${token}` })
//   if (isNil(result) || result.status !== 200 || isNil(result.data) || !result.data.success) {
//     log.error(`[functions.isRegisteredKateneApi]`, inspect(result))
//     return undefined
//   }
//   return result.data.result
// }
